import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import { getTransactionsService } from "../../../services/userServices";

export const walletTransactionAdminContext = createContext({
  transactions: [],
  setTransactions: () => {},
  transactionItem: {},
  setTransactionItem: () => {},
  search: "",
  setSearch: () => {},
  ordering: "",
  setOrdering: () => {},
  txType: "",
  setTxType: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleCloseTransactionModal: () => {},
  handleGetTransactions: () => {},
  handleGetTransactionDetails: () => {},
});

const WalletTransactionAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const [transactions, setTransactions] = useState([]);
  const [transactionItem, setTransactionItem] = useState({});
  const [search, setSearch] = useState("");
  const [ordering, setOrdering] = useState("-created");
  const [txType, setTxType] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  // بستن مودال جزئیات
  const handleCloseTransactionModal = () => {
    setTransactionItem({});
  };

  // دریافت لیست تراکنش‌ها (با پشتیبانی از جستجو، مرتب‌سازی و فیلتر نوع تراکنش)
  const handleGetTransactions = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      search,
      page: isSearch ? 1 : pageNumber,
      page_size: limit,
      ordering,
      ...(txType && { type: txType }),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getTransactionsService("/admin/v2/wallets/transactions/all/", {
        params: objData,
      });
      if (status === 200) {
        setTransactions(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // دریافت جزئیات یک تراکنش خاص (در صورت نیاز به دریافت تکی یا استفاده از اطلاعات موجود در لیست)
  const handleGetTransactionDetails = (item) => {
    setTransactionItem(item);
  };

  return (
    <walletTransactionAdminContext.Provider
      value={{
        transactions,
        setTransactions,
        transactionItem,
        setTransactionItem,
        search,
        setSearch,
        ordering,
        setOrdering,
        txType,
        setTxType,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        handleCloseTransactionModal,
        handleGetTransactions,
        handleGetTransactionDetails,
      }}
    >
      {children}
    </walletTransactionAdminContext.Provider>
  );
};

export default WalletTransactionAdminContext;